jQuery(document).ready(function ($) {

    const $geographie = $('.geographie');
    const $collapse = $geographie.find('.collapse');

    const get_current_geographie = function() {
        return $(this).closest('.geographie');
    };

    const geographie_toggle = function() {
        const $current_geographie = get_current_geographie.call( this );
        const $button = $current_geographie.find('[data-toggle="collapse"]');
        const current_text = $button.text();
        $button.text( $button.attr('data-show_text') ).attr('data-show_text', current_text);
        $current_geographie.toggleClass('-pre-active');
    };

    // Occurs when the collapsible element is about to be shown
    $collapse.on('show.bs.collapse', geographie_toggle );

    // Occurs when the collapsible element is about to be hidden
    $collapse.on('hide.bs.collapse', geographie_toggle );

});